/**
 * Param + equation glossary loaded from shared/glossary/*.json
 */

import equationJson from "../../../shared/glossary/equation.json";
import paramsJson from "../../../shared/glossary/params.json";

export type ParamGlossaryEntry = {
  symbol: string | null;
  short: string;
  summary: string;
  detail: string;
  low: string | null;
  high: string | null;
  interacts_with: string[];
};

export type EquationTerm = {
  id: string;
  symbol: string;
  name: string;
  meaning: string;
  param: string | null;
  role: string;
};

export type EquationOperation = {
  id: string;
  label: string;
  meaning: string;
};

export type EquationInteraction = {
  id: string;
  title: string;
  body: string;
};

export type EquationGlossary = {
  version: number;
  title: string;
  headline: string;
  headline_html: string;
  intro: string;
  secondary: {
    headline: string;
    headline_html: string;
    intro: string;
  };
  terms: EquationTerm[];
  operations: EquationOperation[];
  interactions: EquationInteraction[];
};

type ParamsFile = {
  version: number;
  params: Record<string, ParamGlossaryEntry>;
};

const paramsFile = paramsJson as ParamsFile;
export const PARAM_GLOSSARY: Record<string, ParamGlossaryEntry> =
  paramsFile.params;
export const EQUATION_GLOSSARY: EquationGlossary =
  equationJson as EquationGlossary;

export function getParamHelp(id: string): ParamGlossaryEntry | undefined {
  return PARAM_GLOSSARY[id];
}

export function glossaryIds(): string[] {
  return Object.keys(PARAM_GLOSSARY);
}
